import {
  HttpApiEndpoint,
  HttpApiError,
  HttpApiGroup,
  HttpApiSchema,
} from "@effect/platform";
import { Schema } from "effect";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import { Authorization } from "../auth/middleware";

export const StreamGroup = HttpApiGroup.make("stream")
  .add(
    HttpApiEndpoint.get("subscribeTeamNotifications", "/team/notifications")
      .middleware(Authorization)
      .setUrlParams(
        Schema.Struct({
          topics: Schema.optionalWith(Schema.String, { default: () => "" }),
        }),
      )
      .addSuccess(
        Schema.String.pipe(
          HttpApiSchema.withEncoding({
            kind: "Text",
            contentType: "text/event-stream",
          }),
        ),
      )
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(HttpApiError.InternalServerError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api/streams");
